import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import {
	check_four_bend_bay,
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function Four_bend() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");
	const [measurtement_bc, set_measurtement_bc] = useState("");
	const [measurtement_cd, set_measurtement_cd] = useState("");
	const [measurtement_de, set_measurtement_de] = useState("");
	const [measurtement_ef, set_measurtement_ef] = useState("");

	const [measurtement_af, set_measurtement_af] = useState("");
	const [measurtement_ae, set_measurtement_ae] = useState("");
	const [measurtement_bf, set_measurtement_bf] = useState("");
	const [measurtement_bd, set_measurtement_bd] = useState("");
	const [measurtement_be, set_measurtement_be] = useState("");
	const [measurtement_ce, set_measurtement_ce] = useState("");

	const [measurtement_1a, set_measurtement_1a] = useState("");
	const [measurtement_f2, set_measurtement_f2] = useState("");

	let does_it_work = check_four_bend_bay(
		measurtement_ab,
		measurtement_bc,
		measurtement_cd,
		measurtement_de,
		measurtement_ef,
		measurtement_af,
		measurtement_ae,
		measurtement_bf,
		measurtement_bd,
		measurtement_be,
		measurtement_ce
	);
	let the_summary = "(empty)";

	useEffect(() => {
		let svg_wrap = document.querySelector(".svg_wrap");
	});

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>Four bend</strong> bay
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 180">
						<path
							fill="#D4D0C4"
							d="M205.6 36.4a1.5 1.5 0 1 0-1.2-2.8l-2.5 1a1.5 1.5 0 1 0 1.2 2.8l2.5-1Zm-7.6 3a1.5 1.5 0 1 0-1-2.8l-5 2a1.5 1.5 0 1 0 1 2.8l5-2Zm-10 3.9a1.5 1.5 0 1 0-1-2.7l-5 2a1.5 1.5 0 1 0 1 2.7l5-2Zm-10 4a1.5 1.5 0 1 0-1-2.8l-5 2a1.5 1.5 0 1 0 1 2.8l5-2Zm-9.3 3.5a1.5 1.5 0 0 0-1.8-2.3l-1.9.8-2-.8a1.5 1.5 0 0 0-1.7 2.3 1.5 1.5 0 0 0 1.5 2.6l2.2-.9 2.2.9a1.5 1.5 0 0 0 1.5-2.6Zm-11.4 4.7a1.5 1.5 0 1 0-1-2.8l-5.5 2.2a1.5 1.5 0 0 0 1 2.8l5.5-2.2Zm-10.9 4.4a1.5 1.5 0 0 0-1.1-2.8l-5.5 2.2A1.5 1.5 0 1 0 141 62l5.5-2.2Zm-10.9 4.3a1.5 1.5 0 1 0-1.2-2.8l-5.4 2.2a1.5 1.5 0 0 0 1 2.8l5.6-2.2Zm-11 4.4a1.5 1.5 0 0 0-1-2.8l-5.6 2.2a1.5 1.5 0 1 0 1.1 2.7l5.5-2.1ZM113.6 73a1.5 1.5 0 0 0-1.1-2.9l-5.5 2.2a1.5 1.5 0 0 0 1 2.8l5.6-2.2Zm-11 4.3a1.5 1.5 0 0 0-1-2.8L96 76.7a1.5 1.5 0 1 0 1.2 2.7l5.4-2.1Zm-10.9 4.3a1.5 1.5 0 1 0-1.1-2.8L85 81a1.5 1.5 0 0 0 1.1 2.8l5.5-2.2Zm-11 4.4a1.5 1.5 0 0 0-1-2.8l-5.5 2.1a1.5 1.5 0 1 0 1 2.8l5.5-2.1Zm-10.9 4.3a1.5 1.5 0 0 0-1.1-2.8l-2.8 1.1a1.5 1.5 0 0 0 1.2 2.8l2.7-1Zm55.8-56.7a1.5 1.5 0 0 0-1.2 2.8l2.5 1a1.5 1.5 0 0 0 1.2-2.8l-2.5-1Zm7.4 3a1.5 1.5 0 0 0-1 2.8l5 2a1.5 1.5 0 0 0 1-2.8l-5-2Zm10 4a1.5 1.5 0 0 0-1 2.7l5 2a1.5 1.5 0 0 0 1-2.8l-5-2Zm10 3.9a1.5 1.5 0 0 0-1 2.8l5 2a1.5 1.5 0 0 0 1-2.8l-5-2Zm20.8 8.3a1.5 1.5 0 0 0-1.1 2.7l5.4 2.2a1.5 1.5 0 1 0 1.1-2.8l-5.4-2.1Zm10.9 4.3a1.5 1.5 0 1 0-1.1 2.8l5.5 2.2a1.5 1.5 0 0 0 1-2.8l-5.4-2.2Zm11 4.3a1.5 1.5 0 1 0-1.2 2.8l5.5 2.2a1.5 1.5 0 0 0 1.1-2.8l-5.4-2.2Zm10.9 4.4a1.5 1.5 0 1 0-1.1 2.8l5.5 2.1a1.5 1.5 0 0 0 1-2.7l-5.4-2.2Zm10.9 4.3a1.5 1.5 0 0 0-1 2.8l5.4 2.2a1.5 1.5 0 1 0 1.1-2.8l-5.5-2.2Zm11 4.4a1.5 1.5 0 1 0-1.1 2.8l5.4 2.1a1.5 1.5 0 0 0 1.2-2.7l-5.5-2.2Zm10.9 4.3a1.5 1.5 0 0 0-1 2.8l5.4 2.2a1.5 1.5 0 1 0 1.1-2.8l-5.5-2.2Zm11 4.4a1.5 1.5 0 0 0-1.1 2.8l5.4 2.1a1.5 1.5 0 1 0 1.1-2.8l-5.4-2.1Zm10.9 4.3a1.5 1.5 0 0 0-1 2.8l2.6 1a1.5 1.5 0 0 0 1.2-2.7l-2.8-1Zm-197.8 7c.2-.8 1-1.2 1.9-1l2.7.6a1.5 1.5 0 1 1-.7 3l-2.8-.7c-.8-.2-1.3-1-1-1.9Zm8.4 2.1c.2-.8 1-1.3 1.8-1l5.6 1.3a1.5 1.5 0 0 1-.8 3L73 98.4c-.8-.3-1.3-1-1.1-1.9ZM83 99.4c.2-.8 1-1.3 1.8-1l5.6 1.3a1.5 1.5 0 1 1-.8 3l-5.5-1.5c-.8-.2-1.3-1-1.1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1l5.6 1.3a1.5 1.5 0 1 1-.8 3l-5.5-1.5c-.8-.2-1.3-1-1.1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1.1l5.6 1.4a1.5 1.5 0 1 1-.7 2.9l-5.6-1.4c-.8-.2-1.3-1-1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1.1l5.6 1.4a1.5 1.5 0 1 1-.7 2.9l-5.6-1.4c-.8-.2-1.3-1-1-1.8Zm11.1 2.7c.2-.8 1-1.2 1.9-1l5.5 1.3a1.5 1.5 0 0 1-.7 3l-5.6-1.4c-.8-.2-1.3-1-1-1.9Zm11.1 2.8c.2-.8 1-1.3 1.9-1l5.5 1.3a1.5 1.5 0 0 1-.7 3l-5.6-1.5c-.8-.2-1.3-1-1-1.8Zm11.2 2.8c.2-.8 1-1.3 1.8-1l5.5 1.3a1.5 1.5 0 1 1-.7 3l-5.6-1.5c-.8-.2-1.2-1-1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1.1l2.4.6 2.4-.6a1.5 1.5 0 0 1 1.7 2.2c.2.3.2.6.1 1-.2.8-1 1.3-1.8 1.1l-2.4-.6-2.4.6a1.5 1.5 0 0 1-1.7-2.1c-.2-.4-.2-.7-.1-1.1Zm11.1 2.8c.2-.8 1-1.3 1.8-1.1l5.6 1.4a1.5 1.5 0 1 1-.8 2.9l-5.5-1.4c-.8-.2-1.3-1-1.1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1.1l5.6 1.4a1.5 1.5 0 0 1-.8 2.9l-5.5-1.4c-.8-.2-1.3-1-1.1-1.8Zm11.1 2.7c.2-.8 1-1.2 1.8-1l5.6 1.3a1.5 1.5 0 1 1-.8 3l-5.5-1.4c-.8-.2-1.3-1-1.1-1.9Zm11.1 2.8c.2-.8 1-1.3 1.8-1l5.6 1.3a1.5 1.5 0 0 1-.7 3l-5.6-1.5c-.8-.2-1.3-1-1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.8-1l5.6 1.3a1.5 1.5 0 0 1-.7 3l-5.6-1.5c-.8-.2-1.3-1-1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.9-1.1l5.5 1.4a1.5 1.5 0 1 1-.7 2.9l-5.6-1.4c-.8-.2-1.3-1-1-1.8Zm11.1 2.8c.2-.8 1-1.3 1.9-1.1l5.5 1.4a1.5 1.5 0 1 1-.7 2.9l-5.6-1.4c-.8-.2-1.3-1-1-1.8Zm11.2 2.8c.2-.8 1-1.3 1.8-1.1l5.5 1.4a1.5 1.5 0 1 1-.7 2.9l-5.6-1.4c-.8-.2-1.2-1-1-1.8Zm11.1 2.8c.2-.9 1-1.4 1.8-1.2l2.8.7a1.5 1.5 0 0 1-.8 3l-2.7-.7c-.8-.2-1.3-1-1.1-1.9Zm4.6-47.6a1.5 1.5 0 0 0-.8-3l-2.7.7a1.5 1.5 0 1 0 .7 3l2.8-.7Zm-8.4 2.1a1.5 1.5 0 1 0-.7-3l-5.6 1.4a1.5 1.5 0 1 0 .8 3l5.5-1.4Zm-11 2.7a1.5 1.5 0 0 0-.8-2.9l-5.6 1.4a1.5 1.5 0 1 0 .8 3l5.5-1.5Zm-11.2 2.8a1.5 1.5 0 0 0-.7-2.9l-5.6 1.4a1.5 1.5 0 1 0 .8 3l5.5-1.5Zm-11.1 2.8a1.5 1.5 0 1 0-.7-3l-5.6 1.5a1.5 1.5 0 0 0 .7 2.9l5.6-1.4Zm-11.1 2.8a1.5 1.5 0 1 0-.7-3l-5.6 1.5a1.5 1.5 0 1 0 .7 2.9l5.6-1.4Zm-11.1 2.8a1.5 1.5 0 1 0-.8-3l-5.5 1.4a1.5 1.5 0 0 0 .7 3l5.6-1.4Zm-11.1 2.7a1.5 1.5 0 0 0-.8-2.9l-5.5 1.4a1.5 1.5 0 0 0 .7 3l5.6-1.5Zm-11.1 2.9a1.5 1.5 0 0 0-.8-3l-5.5 1.4a1.5 1.5 0 1 0 .7 3l5.6-1.5Zm-22.3 5.5a1.5 1.5 0 1 0-.7-3l-5.6 1.5a1.5 1.5 0 1 0 .8 2.9l5.5-1.4Zm-11 2.8a1.5 1.5 0 1 0-.8-3l-5.6 1.5a1.5 1.5 0 1 0 .8 2.9l5.5-1.4Zm-11.2 2.7a1.5 1.5 0 1 0-.7-2.8l-5.6 1.3a1.5 1.5 0 1 0 .8 3l5.5-1.4Zm-11.1 2.8a1.5 1.5 0 1 0-.7-2.9l-5.6 1.4a1.5 1.5 0 0 0 .7 3l5.6-1.5Zm-11.1 2.8a1.5 1.5 0 0 0-.7-2.9l-5.6 1.4a1.5 1.5 0 0 0 .7 3l5.6-1.5Zm-11.1 2.8a1.5 1.5 0 0 0-.8-2.9l-5.5 1.4a1.5 1.5 0 0 0 .7 2.9l5.6-1.4Zm-11.1 2.8a1.5 1.5 0 0 0-.8-3l-5.5 1.5a1.5 1.5 0 1 0 .7 2.9l5.6-1.4ZM79.3 143a1.5 1.5 0 1 0-.8-3l-5.5 1.5a1.5 1.5 0 1 0 .7 2.9l5.6-1.4Zm-11.2 2.8a1.5 1.5 0 1 0-.7-3l-2.8.7a1.5 1.5 0 1 0 .8 3l2.7-.7Zm20.4 4.2c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3H90c-.8 0-1.5-.7-1.5-1.5Zm8.7 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.4-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 0 1 0 3H191c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3H214c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.6-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3h-2.9c-.8 0-1.5-.7-1.5-1.5ZM85 90.5a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 1 0 0-3h-3Zm9.2 0a1.5 1.5 0 1 0 0 3h6.2a1.5 1.5 0 0 0 0-3h-6.2Zm12.3 0a1.5 1.5 0 0 0 0 3h6.2a1.5 1.5 0 1 0 0-3h-6.2Zm12.3 0a1.5 1.5 0 0 0 0 3h6.2a1.5 1.5 0 0 0 0-3h-6.2Zm12.4 0a1.5 1.5 0 1 0 0 3h6.1a1.5 1.5 0 0 0 0-3h-6.1Zm12.3 0a1.5 1.5 0 1 0 0 3h6.1a1.5 1.5 0 1 0 0-3h-6.1Zm12.3 0a1.5 1.5 0 0 0 0 3h6.1a1.5 1.5 0 1 0 0-3h-6.1Zm12.2 0a1.5 1.5 0 1 0 0 3h6.2a1.5 1.5 0 0 0 0-3h-6.1Zm12.4 0a1.5 1.5 0 1 0 0 3h6.1a1.5 1.5 0 1 0 0-3h-6.1Zm12.3 0a1.5 1.5 0 0 0 0 3h6.1a1.5 1.5 0 1 0 0-3h-6.1Zm12.3 0a1.5 1.5 0 0 0 0 3h6.2a1.5 1.5 0 0 0 0-3H205Zm12.3 0a1.5 1.5 0 1 0 0 3h6.2a1.5 1.5 0 0 0 0-3h-6.2Zm12.3 0a1.5 1.5 0 0 0 0 3h6.2a1.5 1.5 0 1 0 0-3h-6.2Zm12.4 0a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 0-3h-3Z"
						/>
						<path
							fill="#7BAABD"
							d="M53.5 88.5a5 5 0 0 0-1.5 3.6V142H4a4 4 0 0 0 0 8h52a4 4 0 0 0 4-4V95.4a5 5 0 0 1 1.5-3.5l60.4-60.4a5 5 0 0 1 3.5-1.5h79.2a5 5 0 0 1 3.6 1.5l60.3 60.3a5 5 0 0 1 1.5 3.6V146a4 4 0 0 0 4 4h52a4 4 0 0 0 0-8h-48V92a5 5 0 0 0-1.5-3.5l-65-65a5 5 0 0 0-3.6-1.5h-85.8a5 5 0 0 0-3.6 1.5l-65 65Z"
						/>

						<g className="g_2">
							<path
								className="shape"
								d="M316 175c6 0 11-5 11-11v-11h-11a11 11 0 0 0 0 22Zm0 3a14 14 0 0 0 14-14v-14h-14a14 14 0 1 0 0 28Z"
							/>
							<path d="m312.1 169 .1-1.5.5-1.2.8-1 1.4-1a93 93 0 0 1 2.3-1.2l.6-.5.2-.6-.2-.7-.6-.5a2 2 0 0 0-.9-.2 3 3 0 0 0-.8.2 3 3 0 0 0-1.3.7l-.5.5-1.5-1.7.7-.6 1-.5a6.8 6.8 0 0 1 2.8-.7 5 5 0 0 1 2.1.4 3 3 0 0 1 1.8 2.7c0 .4-.1.8-.3 1.1l-.5.9-.8.6-.8.5a33.9 33.9 0 0 0-2.5 1.5 3 3 0 0 0-.4.6h5.5v2.2H312Z" />
						</g>

						<g className="g_f">
							<path
								className="shape"
								d="M256 175c6 0 11-5 11-11v-11h-11a11 11 0 0 0 0 22Zm0 3a14 14 0 0 0 14-14v-14h-14a14 14 0 1 0 0 28Z"
							/>
							<path d="M252.7 170v-12.8h8.6v2.2H255v3.3h5.1v2h-5v5.3h-2.5Z" />
						</g>

						<g className="g_e">
							<path className="shape" d="M284 87a11 11 0 1 0-11-11v11h11Zm0 3a14 14 0 1 0-14-14v14h14Z" />
							<path d="M288.3 79.8V82h-8.9V69.2h8.7v2.2H282v3h5.4v2H282v3.4h6.4Z" />
						</g>

						<g className="g_d">
							<path className="shape" d="M224 27a11 11 0 1 0-11-11v11h11Zm0 3a14 14 0 1 0-14-14v14h14Z" />
							<path d="M219.4 22V9.2h4.6c1.4 0 2.6.3 3.5.9 1 .5 1.7 1.3 2.1 2.3.5 1 .7 2 .7 3.2a7 7 0 0 1-.7 3.4c-.6 1-1.3 1.7-2.2 2.2-1 .5-2 .8-3.4.8h-4.6Zm8.4-6.4a5 5 0 0 0-.4-2.2c-.3-.6-.8-1.1-1.3-1.5-.6-.3-1.3-.5-2-.5h-2.2v8.4h2.1c.8 0 1.5-.2 2.1-.5.6-.4 1-.9 1.3-1.5.3-.7.4-1.4.4-2.2Z" />
						</g>

						<g className="g_c">
							<path
								className="shape"
								d="M95 16c0 6 5 11 11 11h11V16a11 11 0 0 0-22 0Zm-3 0a14 14 0 0 0 14 14h14V16a14 14 0 1 0-28 0Z"
							/>
							<path d="M99.9 15.5a6.5 6.5 0 0 1 3.6-5.8 6 6 0 0 1 2.7-.6c1.2 0 2.2.3 3 .8a5 5 0 0 1 2 2l-2 1.4a3 3 0 0 0-.8-1.2 3 3 0 0 0-1.1-.6 4 4 0 0 0-1.2-.2 3.4 3.4 0 0 0-2.8 1.4l-.7 1.4a5.5 5.5 0 0 0 0 3.1l.8 1.4 1.2 1c.5.2 1 .3 1.6.3.3 0 .8 0 1.2-.2a2 2 0 0 0 1-.6c.4-.3.7-.7.9-1.1l2 1.1c-.2.7-.6 1.2-1.2 1.7a6.8 6.8 0 0 1-4 1.4c-1 0-1.8-.3-2.5-.6a6.6 6.6 0 0 1-3.3-3.7c-.3-.8-.4-1.6-.4-2.4Z" />
						</g>

						<g className="g_b">
							<path
								className="shape"
								d="M35 76c0 6 5 11 11 11h11V76a11 11 0 0 0-22 0Zm-3 0a14 14 0 0 0 14 14h14V76a14 14 0 1 0-28 0Z"
							/>
							<path d="M51 78.7a3 3 0 0 1-.5 1.8c-.4.5-1 .9-1.6 1.1-.6.3-1.3.4-2 .4h-6.2V69.2h6.9c.6 0 1 .2 1.5.5a3.5 3.5 0 0 1 .9 4.5c-.3.6-.8 1-1.4 1.2a3.2 3.2 0 0 1 2.4 3.3Zm-2.5-.5c0-.3 0-.6-.2-.8a1 1 0 0 0-.5-.6c-.2-.2-.5-.3-.8-.3h-3.8V80h3.7c.3 0 .6 0 .8-.2a1.7 1.7 0 0 0 .8-1.5Zm-5.3-6.9v3.3h3.3l.8-.2.5-.6c.2-.2.2-.5.2-.9 0-.3 0-.6-.2-.8a1.3 1.3 0 0 0-1.2-.8h-3.4Z" />
						</g>

						<g className="g_a">
							<path
								className="shape"
								d="M74 175a11 11 0 0 0 0-22H63v11c0 6 5 11 11 11Zm0 3a14 14 0 1 0 0-28H60v14a14 14 0 0 0 14 14Z"
							/>
							<path d="M72.3 157.2h2.5l4.7 12.8h-2.6l-1.2-3.2h-4.4L70 170h-2.6l4.8-12.8Zm3 7.9-1.8-5.3-1.8 5.3h3.6Z" />
						</g>

						<g className="g_1">
							<path
								className="shape"
								d="M25 164c0-6-5-11-11-11H3v11a11 11 0 0 0 22 0Zm3 0a14 14 0 0 0-14-14H0v14a14 14 0 1 0 28 0Z"
							/>
							<path d="M17.5 166.8v2.2h-7.3v-2.2h2.6v-5.4l-.5.4a6.6 6.6 0 0 1-1.7.8h-.8v-2.2c.3 0 .5 0 .8-.2a7.6 7.6 0 0 0 2.2-1.5h2.4v8.1h2.3Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 18" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h3>
					<strong>Wall</strong> Measurements
				</h3>

				<div className="measurtement_wrapper">
					{["ab", "bc", "cd", "de", "ef"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					<strong>Cross</strong> Measurements
				</h3>

				<div className="measurtement_wrapper">
					{["af", "ae", "bf", "be", "bd", "ce"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h3>
					Optional <strong>Distances</strong>
				</h3>

				<div className="measurtement_wrapper">
					{["1a", "f2"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<Render_status does_it_work={does_it_work} />
				{["ab", "bc", "cd", "de", "ef", "af", "ae", "bf", "bd", "be", "ce", "1a", "f2"].map((key) => {
					let number = parseInt(eval("measurtement_" + key));
					if (isNaN(number)) number = 0;

					console.log(number);

					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: number,
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="Four Bend" />
			</div>
		</div>
	);
}
